import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Group } from '@mantine/core';
import { Home, ChevronRight, ChevronLeft } from 'tabler-icons-react';
import AppContext from './Context/index';
import TimerEvent from './TimerEvent/TimerEvent';

const PaymentStatus = () => {
  const navigate = useNavigate();

  const appContextState = useContext(AppContext);
  const { appState } = appContextState;

  return (
    <Group position="apart" style={{ marginBottom: '2%' }}>
      <Button
        onClick={() => navigate(-1)}
        className="back-btn"
        leftIcon={appState?.language === 'ar' ? <ChevronRight /> : <ChevronLeft />}
        radius="xl"
        size="md"
        style={{ paddingInline: '1% 2%', backgroundColor: '#2C5864' }}
      >
        {appState?.language === 'ar' ? 'رجوع' : 'Back'}
      </Button>
      <TimerEvent />

      <Button
        onClick={() => navigate('/')}
        leftIcon={<Home />}
        color="blue"
        radius="xl"
        size="md"
        variant="outline"
        style={{ paddingInline: '2% 2%', color: '#2C5864', borderColor: '#2C5864' }}
      >
        {appState?.language === 'ar' ? 'الرئيسية' : 'Home'}
      </Button>
    </Group>
  );
};
export default PaymentStatus;
